import React from 'react';
import { UserActivityDetailSkeleton } from '@components/Feed/User/Skeleton';
import { RowContainer } from './ReleaseRow';

export const RowSkeleton = ({ count = 4 }: { count?: number }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <RowContainer
          key={i}
          css={{
            pointerEvents: 'none',
          }}
        >
          <UserActivityDetailSkeleton />
        </RowContainer>
      ))}
    </>
  );
};
